import { render, staticRenderFns } from "./vue_jqxtabs.vue?vue&type=template&id=dc26da52"
import script from "./vue_jqxtabs.vue?vue&type=script&lang=js"
export * from "./vue_jqxtabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports